import React from 'react';

import { VpPluginSwitchSection } from './VpPluginSwitchSection';
import { VpPluginBoxShadowInputs } from '../..';

export const VpPluginBoxShadowSection = () => {
  return (
    <VpPluginSwitchSection name="showBoxShadow" label="BOX SHADOW">
      <VpPluginBoxShadowInputs />
    </VpPluginSwitchSection>
  );
};

export default VpPluginBoxShadowSection;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/VpPluginBoxShadowSection.jsx